export const formatEarnedDate = (dateStr: string | null) => {
  if (!dateStr) return null;
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return null;
  }
};

export const formatPeriodMetadata = (metadata?: Record<string, any> | null) => {
  if (!metadata || !metadata.period_type) return null;

  const periodType = metadata.period_type;
  const periodStart = metadata.period_start;
  const periodEnd = metadata.period_end;

  if (!periodStart) return null;

  try {
    if (periodType === 'daily') {
      const dateStr = typeof periodStart === 'string' ? periodStart : String(periodStart);
      const date = new Date(dateStr + 'T00:00:00Z');
      if (isNaN(date.getTime())) {
        const date2 = new Date(dateStr);
        if (isNaN(date2.getTime())) {
          return null;
        }
        return date2.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }

    if (periodType === 'weekly') {
      const startStr = typeof periodStart === 'string' ? periodStart : String(periodStart);
      const startDate = new Date(startStr + 'T00:00:00Z');
      if (isNaN(startDate.getTime())) {
        const startDate2 = new Date(startStr);
        if (isNaN(startDate2.getTime())) {
          return null;
        }
        const startFormatted = startDate2.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric'
        });
        if (periodEnd) {
          const endStr = typeof periodEnd === 'string' ? periodEnd : String(periodEnd);
          const endDate2 = new Date(endStr);
          if (!isNaN(endDate2.getTime())) {
            const endFormatted = endDate2.toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            });
            return `${startFormatted} – ${endFormatted}`;
          }
        }
        return startFormatted;
      }
      const startFormatted = startDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
      if (periodEnd) {
        const endStr = typeof periodEnd === 'string' ? periodEnd : String(periodEnd);
        const endDate = new Date(endStr + 'T00:00:00Z');
        if (!isNaN(endDate.getTime())) {
          const endFormatted = endDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });
          return `${startFormatted} – ${endFormatted}`;
        }
        const endDate2 = new Date(endStr);
        if (!isNaN(endDate2.getTime())) {
          const endFormatted = endDate2.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });
          return `${startFormatted} – ${endFormatted}`;
        }
      }
      return startFormatted;
    }

    if (periodType === 'monthly') {
      const dateStr = typeof periodStart === 'string' ? periodStart : String(periodStart);
      const date = new Date(dateStr + 'T00:00:00Z');
      if (isNaN(date.getTime())) {
        const date2 = new Date(dateStr);
        if (isNaN(date2.getTime())) {
          return null;
        }
        return date2.toLocaleDateString('en-US', {
          month: 'long',
          year: 'numeric'
        });
      }
      return date.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
      });
    }
  } catch (error) {
    console.error('Error formatting period metadata:', error);
    return null;
  }

  return null;
};
